module.exports = new __parcel__URL__("premiumLozenge.aa9b0435.svg").toString();